import { formatPrismicData } from '@monofront/business/utils';
import { WidgetTrustpilotProps, IWidgetTrustpilotProps } from './types';

export const mapWidgetTrustpilot = ({
  prismicContent,
}: {
  prismicContent: WidgetTrustpilotProps['slice'];
}): IWidgetTrustpilotProps => {
  const {
    title,
    templateid,
    height,
    width,
    theme,
    stars,
    titleDecoration,
    backgroundColor,
  }: IWidgetTrustpilotProps = formatPrismicData(prismicContent.primary);

  return {
    title,
    templateid,
    height,
    width,
    theme,
    stars,
    titleDecoration,
    backgroundColor,
  };
};
